import {getProducts} from './thunk';

export const componentsBuilder = (builder: any) => {
  builder
    .addCase(getProducts.pending, (state: any) => {
      if (!state.products?.items?.length) state.loading += 1;
    })
    .addCase(getProducts.fulfilled, (state: any, action: any) => {
      let temp: any = {};
      if (action.payload?.data) {
        if (
          state.products &&
          state.products?.items?.length &&
          state.products?.page !== action.payload.data?.page
        ) {
          // Pagination: append new items to existing list
          temp = state.products;
          temp.items.push(...(action.payload.data.items || []));
          temp.page = action.payload.data.page;
          temp.size = action.payload.data.size;
          temp.total_items = action.payload.data.total_items;
          temp.total_pages = action.payload.data.total_pages;
        } else {
          // First load or reset
          temp = {
            ...action.payload.data,
            items: action.payload.data.items || []
          };
        }
      } else {
        temp = {
          ...action.payload,
          items: action.payload.items || []
        };
      }
      state.products = temp;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getProducts.rejected, (state: any, action: any) => {
      state.error = action.payload?.message || 'Error fetching products';
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
